<template>
  <div id="contenedor-eliminar-contrato-programa-obra">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Plazo de Programa </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el plazo del programa? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarContratoPrograma"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixProgramaContrato from './mixProgramaContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarProgramaObraContrato',
  mixins: [mixProgramaContrato],
  props: {
    programaObraEliminar: Object,
    idContrato: String,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
